<template>
  <div class="search-header">
    <img @click="goBack" class="back" src="@/assets/imgs/nav_icon_back.png" />
    <div class="center">{{title}}</div>
    <div class="back"></div>
  </div>
</template>
<script>
export default {
  name: "OrderDetailHeader",
  props: {
    title: String,
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>
<style lang="stylus" scoped>
.search-header {
  height: 88px;
  background: rgba(244, 244, 244, 1);
  padding: 0 22px 0 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .center {
    font-size: 36px;
    font-weight: 600;
    color: rgba(34, 34, 34, 1);
    flex: 1;
    text-align: center;
  }

  .back {
    width: 24.83px;
    height: 45.66px;
  }
}
</style>
